"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIdKeyPair = exports.getSelectedKeys = exports.a = void 0;
const lodash_1 = __importDefault(require("lodash"));
exports.a = {};
const getSelectedKeys = _ref => {
  let {
    data,
    groups,
    categories
  } = _ref;
  const groupsContainsKey = lodash_1.default.some(groups, 'key');
  const categoriesContainsKey = lodash_1.default.some(categories, 'key');
  if (!groupsContainsKey && !categoriesContainsKey) {
    return [];
  }
  if (groupsContainsKey && categoriesContainsKey) {
    // make sure key doesn't exist in both groups and categories
    throw new Error(`Key cannot be present in 'groups' and 'categories' props at the same time.`);
  }
  // make sure every group item has a key if one of them does
  let selectedKeys = [];
  if (groupsContainsKey) {
    if (!lodash_1.default.every(groups, 'key')) {
      throw new Error(`Key must be present on items in 'groups' prop.`);
    }
    selectedKeys = lodash_1.default.map(groups, 'key');
  }
  // make sure every category item has a key if one of them does
  if (categoriesContainsKey) {
    if (!lodash_1.default.every(categories, 'key')) {
      throw new Error(`Key must be present on items in 'categories' prop.`);
    }
    selectedKeys = lodash_1.default.map(categories, 'key');
  }
  const keys = lodash_1.default.chain(data).flatMap(i => i.data.map(j => j.key)).uniq().value();
  if (!selectedKeys.every(k => keys.includes(k))) {
    throw new Error(`Some or all of the selected keys provided do not exist in the data.`);
  }
  return selectedKeys;
};
exports.getSelectedKeys = getSelectedKeys;
const getIdKeyPair = grouping => grouping.map(function () {
  let {
    id,
    key
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return `${id}-${key}`;
});
exports.getIdKeyPair = getIdKeyPair;